import React from "react";
import { Modal, Button } from "@toddle-edu/ds-web";
import { useI18n } from "Hooks";
import ReorderMedia from "../ReorderMedia";
import classes from "./EditAttachmentModal.scss";

const style = {
  editAttachmentModalBody: {
    overflowY: "auto",
    paddingTop: "8px",
    paddingBottom: "8px",
  },
  footerContainer: {
    paddingTop: "16px",
  },
};

export default function EditAttachmentModal(props) {
  const {
    attachments,
    updatePost,
    setToastMsg,
    onClose,
    onDoneClick,
    setPostAttachments,
    showEditAttachmentModal,
    studentActivityData,
    studentIds,
    selectedStudentForActivity,
    isActivityPost = false,
  } = props;

  const { t } = useI18n();
  const [studentActivities, setStudentActivities] = React.useState(
    studentActivityData
  );
  const onDoneClickReorder = () => {
    updatePost({
      studentActivityData: studentActivities,
    });
    onClose();
  };
  return (
    <Modal
      width="480px"
      height="600px"
      isOpen={showEditAttachmentModal}
      onClose={onClose}
    >
      <Modal.Header
        title={t("journal:reorder_media_pascal_case")}
        subtitle={t("journal:reorder_media_subtext", {
          media: t("common:lowercase", {
            text: t("common:media"),
          }),
        })}
        isClosable
      />
      <Modal.Body style={style.editAttachmentModalBody}>
        <ReorderMedia
          postAttachments={attachments}
          setPostAttachments={
            isActivityPost ? setStudentActivities : setPostAttachments
          }
          updatePost={updatePost}
          setToastMsg={setToastMsg}
          studentActivityData={studentActivityData}
          studentIds={studentIds}
          selectedStudentForActivity={selectedStudentForActivity}
          isActivityTrackingPost={isActivityPost}
          studentActivities={studentActivities}
        />
      </Modal.Body>
      <Modal.Footer style={style.footerContainer}>
        <div className={classes.editAttachmentModalFooter}>
          <div className={classes.editFooterRightContainer}>
            <Button variant="outlined-subtle" size={"large"} onClick={onClose}>
              {t("common:cancel")}
            </Button>
            <Button
              variant={"progressive"}
              size={"large"}
              onClick={isActivityPost ? onDoneClickReorder : onDoneClick}
            >
              {t("common:done")}
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
